import React from 'react';

const ControlButtonAdd = ({onClick, text}) => {
    return (
        <button onClick={()=>onClick()} className='bg-green-400 mx-auto p-2 rounded-2xl w-[50%] shadow shadow-xl hover:shadow-2xl duration-300'>{text?text:"AGREGAR"}</button>
    );
}
 
export default ControlButtonAdd;